import { useRef } from "react";
import { useDispatch } from "react-redux";
import { getResources } from "../../../../../redux/actions/resources";

function useHandlePagination(filters: any) {
  const dispatch = useDispatch();

  const rowsPerPage = useRef<number>(8);
  const pageNumber = useRef<number>(1);

  const nextPage = () => {
    pageNumber.current++;
    getResourcesFromAPI();
  };

  const resetPage = () => {
    pageNumber.current = 1;
    getResourcesFromAPI();
  };

  const getResourcesFromAPI = () => {
    const pagination = {
      pageNumber: pageNumber.current,
      rowsPerPage: rowsPerPage.current,
    };
    dispatch(getResources({ filters, pagination }));
  };

  return { nextPage, resetPage, rowsPerPage, getResourcesFromAPI };
}

export default useHandlePagination;
